import { render } from "./index.vue?vue&type=template&id=638cc64c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=638cc64c&scoped=true&lang=scss"

import exportComponent from "D:\\work\\cs-player\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-638cc64c"]])

export default __exports__